"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.syntheticProcess = exports.removeCashResponseTapeArtifacts = exports.addCashResponseTapeArtifacts = void 0;
const lodash = __importStar(require("lodash"));
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const tape_builder_base_1 = require("../types/tape-builder-base");
const { cloneDeep } = lodash;
const createCashResponseTape = (params) => {
    const { cashBalancesFeedContext, receivableResponseTape } = params;
    const { artifactDocumentId, creditFacilitySlug } = cashBalancesFeedContext;
    (0, common_1.finleyAssert)(creditFacilitySlug, 'creditFacilitySlug of cashBalancesFeedContext type must be defined');
    return {
        id: params.id ?? (0, uuid_1.v4)(),
        type: 'cashResponseTape',
        configuration: {
            cashBalancesFeedContextArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)(cashBalancesFeedContext.artifactSlug),
            receivableResponseTapeArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)(receivableResponseTape?.artifactSlug),
        },
        loanProductSlug: null,
        creditFacilitySlug,
        artifactDocumentId,
        externalFilename: null,
        artifactSlug: `cashResponseTape_${creditFacilitySlug}`,
    };
};
/**
 * Inserts a synthetic "cashResponseTape" between its cash inputs
 * (cashBalancesFeedContext and, for non-direct-insert graphs,
 * receivableResponseTape) and the report output (borrowingBaseReport or
 * directInsertBorrowingBaseReport). A single cashResponseTape may fan out to
 * multiple directInsertBorrowingBaseReports that share one cashBalancesFeedContext.
 *
 *                        *** Current ***
 * +-------------------------+      +---------------------+
 * | cashBalancesFeedContext | ---> | borrowingBaseReport |
 * +-------------------------+      +---------------------+
 *  (receivableResponseTape ---> borrowingBaseReport also exists, non-direct-insert)
 *
 *                        *** Revised ***
 * +-------------------------+      +------------------+      +---------------------+
 * | cashBalancesFeedContext | ---> | cashResponseTape | ---> | borrowingBaseReport |
 * +-------------------------+      +------------------+      +---------------------+
 *                                          ^
 * +-------------------------+              |
 * |  receivableResponseTape | -------------+  (omitted for directInsertBorrowingBaseReport)
 * +-------------------------+
 */
const addCashResponseTapeArtifacts = (dbGraph) => {
    // Check for "CashBalancesFeedContexts", as they will act as our basis for this synthetic transaction
    // It there aren't, can simply just return back early since nothing to mutate
    const cashBalancesFeedContextsInGraph = utils.filterCashBalancesFeedContexts({
        dataTapes: dbGraph.dataTapes,
    });
    if (cashBalancesFeedContextsInGraph.length === 0) {
        return dbGraph;
    }
    const clonedDbGraph = cloneDeep(dbGraph);
    const { dataTapes } = clonedDbGraph;
    const { dataTapeDependencies } = clonedDbGraph;
    // get all ReceivableResponseTapes needed for receivables input to createCashResponseTape
    const receivableResponseTapesInGraph = utils.filterReceivableResponseTapes({
        dataTapes: dbGraph.dataTapes,
    });
    const receivableResponseTapeIds = receivableResponseTapesInGraph.map(({ id }) => id);
    const dependenciesToAdd = [];
    const dependenciesToRemove = [];
    for (const cashBalancesFeedContext of cashBalancesFeedContextsInGraph) {
        const { id, artifactSlug } = cashBalancesFeedContext;
        const cashResponseTapeId = (0, uuid_1.v4)();
        const cashBalancesFeedContextInputDependencies = utils.getDependenciesByInputId({
            dataTapeDependencies,
            inputArtifactId: id,
        });
        // this is pretty bad back, but we have some odd case there we want
        // the cash balance feed tape to be attached to two different direct insert bbr nodes
        // for the same cf slug.  this is just a series of check to all this behavior for direct insert bbr graphs
        // and reject this behavior to our typical graphs.
        const cashBalanceFeedContextOutputTypes = new Set();
        cashBalancesFeedContextInputDependencies.forEach((cashBalancesFeedContextToBorrowingBaseDependency) => {
            const cashOutputArtifact = dataTapes.find((tape) => tape.id ===
                cashBalancesFeedContextToBorrowingBaseDependency.outputArtifactId);
            (0, common_1.finleyAssert)(cashOutputArtifact, `Failed to find output artifact for cashBalancesFeedContext [artifactSlug:${artifactSlug}], expected to find one`);
            cashBalanceFeedContextOutputTypes.add(cashOutputArtifact.type);
        });
        (0, common_1.finleyAssert)(cashBalanceFeedContextOutputTypes.size === 1, `cashBalancesFeedContext [artifactSlug:${artifactSlug}] can only belong to direct insert borrowing base nodes or single borrowing base report node.`);
        if (Array.from(cashBalanceFeedContextOutputTypes)[0] === 'borrowingBaseReport') {
            (0, common_1.finleyAssert)(cashBalancesFeedContextInputDependencies.length === 1, `cashBalancesFeedContext [artifactSlug:${artifactSlug}] can only belong to a single borrowing base report node.`);
        }
        // receivableResponseTape is undefined in directInsertBorrowingBaseReport graphs
        let receivableResponseTape;
        cashBalancesFeedContextInputDependencies.forEach((cashBalancesFeedContextToBorrowingBaseDependency) => {
            const cashOutputArtifact = dataTapes.find((tape) => tape.id ===
                cashBalancesFeedContextToBorrowingBaseDependency.outputArtifactId);
            (0, common_1.finleyAssert)(cashOutputArtifact, `Failed to find output artifact for cashBalancesFeedContext [artifactSlug:${artifactSlug}], expected to find one`);
            // Recall that we won't have this if we're using "directInsertBorrowingBaseReport"
            // so no need to create these synthetic relationships for this
            if (cashOutputArtifact.type !== 'directInsertBorrowingBaseReport') {
                const receivableResponseTapeToBorrowingBaseDependencies = dataTapeDependencies.filter((dep) => receivableResponseTapeIds.includes(dep.inputArtifactId) &&
                    dep.outputArtifactId ===
                        cashBalancesFeedContextToBorrowingBaseDependency.outputArtifactId);
                (0, common_1.finleyAssert)(receivableResponseTapeToBorrowingBaseDependencies.length === 1, new common_1.error.FinleyError(`receivableResponseTape should only have 1 dependency to BorrowingBaseReport [found:${receivableResponseTapeToBorrowingBaseDependencies.length}] when managing cashResponseTape [artifactSlug:${artifactSlug}]`));
                const receivableResponseTapeToBorrowingBaseDependency = receivableResponseTapeToBorrowingBaseDependencies[0];
                receivableResponseTape = dataTapes.find((dt) => dt.id ===
                    receivableResponseTapeToBorrowingBaseDependency.inputArtifactId);
                (0, common_1.finleyAssert)(receivableResponseTape, new common_1.error.FinleyError('addCashResponseTapeArtifacts: receivableResponseTape should exist'));
            }
            // we need to remove this for each cashBalancesFeedContextToBorrowingBaseDependency
            // Removing existing dependency between "CashBalancesFeedContext" and output artifact "BorrowingBaseReport"
            dependenciesToRemove.push(cashBalancesFeedContextToBorrowingBaseDependency);
            // need to add this for each cashBalancesFeedContextToBorrowingBaseDependency
            // Add new graph-edge between new "CashResponseTape" to existing output artifact "BorrowingBaseReport"
            dependenciesToAdd.push({
                inputArtifactId: cashResponseTapeId,
                outputArtifactId: cashBalancesFeedContextToBorrowingBaseDependency.outputArtifactId,
            });
        });
        // these only get added 1 time
        // Add new graph-edge between existing "CashBalancesFeedContext" to new "CashResponseTape"
        dependenciesToAdd.push({
            inputArtifactId: cashBalancesFeedContext.id,
            outputArtifactId: cashResponseTapeId,
        });
        // this only gets added 1 time
        if (receivableResponseTape) {
            // Add new graph-edge between new "CashResponseTape" to existing "ReceivableResponseTape"
            dependenciesToAdd.push({
                inputArtifactId: receivableResponseTape.id,
                outputArtifactId: cashResponseTapeId,
            });
        }
        // add cashResponseTape to dataTapes
        const newCashResponseTape = createCashResponseTape({
            id: cashResponseTapeId,
            cashBalancesFeedContext,
            receivableResponseTape,
        });
        dataTapes.push(newCashResponseTape);
    }
    dependenciesToAdd.forEach((dep) => {
        dataTapeDependencies.push(dep);
    });
    const cleanedDeps = utils.removeDependencies({
        dataTapeDependencies,
        dependenciesToRemove,
    });
    return { dataTapeDependencies: cleanedDeps, dataTapes };
};
exports.addCashResponseTapeArtifacts = addCashResponseTapeArtifacts;
/**
 * Inverse of {@link addCashResponseTapeArtifacts}: drops the synthetic
 * cashResponseTape and reconnects cashBalancesFeedContext directly to the
 * report output(s). Direct-insert reports may share one cashResponseTape, so
 * every output edge is rebuilt from cashBalancesFeedContext.
 *
 *                        *** Current ***
 * +-------------------------+      +------------------+      +---------------------+
 * | cashBalancesFeedContext | ---> | cashResponseTape | ---> | borrowingBaseReport |
 * +-------------------------+      +------------------+      +---------------------+
 *
 *                        *** Revised ***
 * +-------------------------+      +---------------------+
 * | cashBalancesFeedContext | ---> | borrowingBaseReport |
 * +-------------------------+      +---------------------+
 */
const removeCashResponseTapeArtifacts = (dbGraph) => {
    const cashResponseTapesInGraph = utils.filterCashResponseTapes({
        dataTapes: dbGraph.dataTapes,
    });
    if (cashResponseTapesInGraph.length === 0) {
        return dbGraph;
    }
    const clonedDbGraph = cloneDeep(dbGraph);
    const { dataTapes } = clonedDbGraph;
    let { dataTapeDependencies } = clonedDbGraph;
    for (const cashResponseTape of cashResponseTapesInGraph) {
        // Remove synthetic "CashResponseTape" artifact from dataTapes
        dataTapes.splice(utils.findTapeIndex({ dataTapes, tape: cashResponseTape }), 1);
        // Fetch associated dependencies to "CashResponseTape"
        const cashBalancesFeedContext = utils.findArtifactBySlug({
            dataTapes,
            artifactSlug: cashResponseTape.configuration.cashBalancesFeedContextArtifactSlug,
        });
        dataTapeDependencies = utils.removeDependency({
            dataTapeDependencies,
            dependencyToRemove: {
                inputArtifactId: cashBalancesFeedContext.id,
                outputArtifactId: cashResponseTape.id,
            },
        });
        if (cashResponseTape.configuration.receivableResponseTapeArtifactSlug) {
            const receivableResponseTape = utils.findArtifactBySlug({
                dataTapes,
                artifactSlug: cashResponseTape.configuration.receivableResponseTapeArtifactSlug,
            });
            dataTapeDependencies = utils.removeDependency({
                dataTapeDependencies,
                dependencyToRemove: {
                    inputArtifactId: receivableResponseTape.id,
                    outputArtifactId: cashResponseTape.id,
                },
            });
        }
        const cashResponseTapeInputDependencies = utils.getDependenciesByInputId({
            dataTapeDependencies,
            inputArtifactId: cashResponseTape.id,
        });
        // Direct-insert reports can share a cash response tape.
        for (const dependency of cashResponseTapeInputDependencies) {
            dataTapeDependencies = utils.removeDependency({
                dataTapeDependencies,
                dependencyToRemove: dependency,
            });
            dataTapeDependencies.push({
                inputArtifactId: cashBalancesFeedContext.id,
                outputArtifactId: dependency.outputArtifactId,
            });
        }
    }
    return { dataTapeDependencies, dataTapes };
};
exports.removeCashResponseTapeArtifacts = removeCashResponseTapeArtifacts;
exports.syntheticProcess = {
    toDb: exports.addCashResponseTapeArtifacts,
    fromDb: exports.removeCashResponseTapeArtifacts,
};
//# sourceMappingURL=cashResponseTape.js.map